import * as React from 'react'
import BlankLayout from '@/components/Layouts/BlankLayout'
import CompanyLayout from '@/components/Layouts/CompanyLayout'
import DefaultLayout from '@/components/Layouts/DefaultLayout'
import ErrorLayout from '@/components/Layouts/ErrorLayout'
import MemberLayout from '@/components/Layouts/MemberLayout'
import SimpleLayout from '@/components/Layouts/SimpleLayout'

export type LayoutType = 'blank' | 'company' | 'default' | 'error' | 'member' | 'simple'

export function getLayoutComponent(
  layout: LayoutType,
  { children }: { children: React.ReactNode },
  pathname?: string,
): React.ReactElement {
  switch (layout) {
    case 'blank':
      return <BlankLayout>{children}</BlankLayout>
    case 'company':
      return <CompanyLayout>{children}</CompanyLayout>
    case 'error': {
      const statusCode = pathname ? parseInt(pathname.split('/')[2] || '500', 10) : 500
      return <ErrorLayout statusCode={statusCode}>{children}</ErrorLayout>
    }
    case 'member':
      return <MemberLayout>{children}</MemberLayout>
    case 'simple':
      return <SimpleLayout>{children}</SimpleLayout>
    case 'default':
    default:
      return <DefaultLayout>{children}</DefaultLayout>
  }
}
